import Stack from "@mui/material/Stack"
import Snackbar from "@mui/material/Snackbar"
import MuiAlert, { AlertProps } from "@mui/material/Alert"
import { forwardRef, useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNewFrameShown } from "../../../next/shell/useNewFrameShown"
import { isBillingRefusalMessage } from "../../../utils/billingRefusals"

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

export const SnackbarMUI = () => {
  const [open, setOpen] = useState(false)
  const storedSnackMessage = useSelector(
    (state: any) => state.generalStore.snackMessage
  )

  const inNewFrame = useNewFrameShown()

  useEffect(() => {
    setOpen(true)
  }, [storedSnackMessage])

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return
    }

    setOpen(false)
  }

  // The new frame's strip already says what a locked account's refusal says (walkthrough decision 5).
  if (inNewFrame && storedSnackMessage?.type === "error" && isBillingRefusalMessage(storedSnackMessage.message)) return null

  return (
    <>
      {storedSnackMessage && (
        <Stack sx={{ width: "100%" }}>
          <Snackbar
            sx={{ minWidth: "320px" }}
            open={open}
            autoHideDuration={5000}
            onClose={handleClose}
          >
            <Alert
              onClose={handleClose}
              severity={storedSnackMessage.type}
              sx={{ width: "100%" }}
            >
              {storedSnackMessage.message}
            </Alert>
          </Snackbar>
        </Stack>
      )}
    </>
  )
}
